import { jsx } from "react/jsx-runtime";
import { TextInputFieldWUT } from "../../../ui/text-input-field/text-input-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const ContactsLastNameWUT = (props) => {
  const fieldType = FIELD_TYPES.CONTACTS_LAST_NAME;
  return /* @__PURE__ */ jsx(TextInputFieldWUT, { ...props, fieldType });
};
export {
  ContactsLastNameWUT
};
//# sourceMappingURL=contacts-last-name-wut.js.map
